import { makeStyles } from "@mui/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { dateFormat, timeFormat } from "../../../util/DateUtil";
import Button from "../../UI/Button";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  cursorLink: {
    cursor: "pointer",
  },
  submit: {
    marginRight: "8px",
  },
  loadingRemove: {
    marginRight: "10px",
    marginLeft: "10px",
  },
});

const PresencaPorDataTable = ({ presencas, handleChangePage, setPresenca }) => {
  const classes = useStyles();

  return (
    <>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={presencas.size ? presencas.size : 0}
        component="div"
        count={presencas.totalElements}
        page={presencas.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          from +
          "-" +
          to +
          " de " +
          (count !== -1 ? count + " registros" : " mais de " + to)
        }
        ActionsComponent={TablePaginationActions}
      />
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Turma</TableCell>
            <TableCell>Disciplina</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Cronograma Aula</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {presencas.content.map((presenca, index) => (
            <TableRow key={presenca.codigo}>
              <TableCell>
                {presenca.tdp && presenca.tdp.turma
                  ? presenca.tdp.turma.descricao
                  : ""}
              </TableCell>
              <TableCell>
                {presenca.tdp && presenca.tdp.disciplina
                  ? presenca.tdp.disciplina.descricao
                  : ""}
              </TableCell>
              <TableCell>
                {presenca.data ? dateFormat(presenca.data) : ""}
              </TableCell>
              <TableCell>
                {presenca.cronograma &&
                  "Aula " +
                    presenca.cronograma.cronogramaAula.ordemAula +
                    " : " +
                    timeFormat(
                      presenca.cronograma.cronogramaAula.horarioInicio
                    ) +
                    " - " +
                    timeFormat(presenca.cronograma.cronogramaAula.horarioFim)}
              </TableCell>
              <TableCell>
                <Button onClick={() => setPresenca(presenca)}>
                  Selecionar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={presencas.size ? presencas.size : 0}
        component="div"
        count={presencas.totalElements}
        page={presencas.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          from +
          "-" +
          to +
          " de " +
          (count !== -1 ? count + " registros" : " mais de " + to)
        }
        ActionsComponent={TablePaginationActions}
      />
    </>
  );
};

export default PresencaPorDataTable;
